import React, { useEffect, useState } from "react";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import { ChevronDown, X } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import { Input } from "@/components/ui/input";

interface AssignMultiSelectProps {
  options: Array<{ label: string; key: string }>;
 
//   onChange: (value: string[]) => void;
  placeholder?: string;
  className?: string;
  handleSelectionDone: (value: any) => void;
  selectedValues?: string[];
  onSelectedValuesChange?: (value: string[]) => void;
  resetOnDone?: boolean;
  applyOnClearAll?: boolean;
}

const AssignMultiSelect: React.FC<AssignMultiSelectProps> = ({
  options,

//   onChange,
  placeholder = "Select Status",
  className,
  handleSelectionDone,
  selectedValues,
  onSelectedValuesChange,
  resetOnDone = true,
  applyOnClearAll = false,
}) => {
  const [open, setOpen] = useState(false);
  const [internalValue, setInternalValue] = useState<string[]>(selectedValues ?? []);
  // const [preValues, setPreValues] = useState<string[]>([]);
  const [searchTerm, setSearchTerm] = useState("");
  const value = internalValue;

  // const checkPreValuesAreSameAsSelectedValues = () => {
  //   // if(preValues.length === 0 || internalValue?.length === 0) return true;
  //   return internalValue.every((value) => preValues?.includes(value));
  // };

  useEffect(() => {
    if (!selectedValues) return;
    setInternalValue(selectedValues);
  }, [selectedValues]);

  const setValue = (next: string[]) => {
    setInternalValue(next);
    if (selectedValues != null) onSelectedValuesChange?.(next);
  };

  const handleToggle = (optionKey: string) => {
    const newValue = value.includes(optionKey)
      ? value.filter((v: any) => v !== optionKey)
      : [...value, optionKey];
    setValue(newValue);
  };

  const handleClear = (e: React.MouseEvent) => {
    e.stopPropagation();
    setValue([]);
  };

  const selectedLabels = options
    .filter((opt) => value.includes(opt.key))
    .map((opt) => opt.label);
  const filteredOptions = options.filter((opt) =>
    opt.label.toLowerCase().includes(searchTerm.toLowerCase().trim()),
  );

  const handleToggleAll = () => {
    if(value.length === filteredOptions.length) {
      setValue([]);
    } else {
      setValue(filteredOptions.map((opt) => opt.key));
    }
  };

  const isActive = value.length > 0;

  return (
    // <Popover open={open} onOpenChange={(next) => {
    //   console.log("next", next);
    //   console.log("internalValue", internalValue);
    //   console.log("preValues", preValues);
    //   console.log("checkPreValuesAreSameAsSelectedValues", checkPreValuesAreSameAsSelectedValues());
    //   if(next) {
    //     setOpen(true);
    //     return;
    //   }
    //   if(checkPreValuesAreSameAsSelectedValues()) {
    //     setInternalValue(preValues);
    //     setOpen(false);
    //     return;
    //   }
    // }}>
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          role="combobox"
          className={cn(
            "h-9 pr-0   bg-[#E8E9F3] border font-normal border-[#CFD2EB] teachers  text-black rounded-full px-3 py-1 text-sm [>svg]:text-black",
            className,
          )}
        >
          <span className="truncate">
            {value.length === 0
              ? placeholder
              : ( value.length === 1 && false )
                ? selectedLabels[0]
                : `${placeholder} (${value.length}) `}
          </span>
          <div className="flex items-center gap-1 ml-2">
            {isActive && false && (
              <X
                onPointerDown={(e) => {
                  e.stopPropagation();
                }}
                className="h-4 w-4 opacity-70 hover:opacity-100 z-100 relative"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation(); 
                  console.log("clicked");
                  handleClear(e);
                }}
              />
            )}
            <ChevronDown className="h-4 w-4 opacity-50 shrink-0" />
          </div>
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[350px] p-0" align="start">
        <div className="p-2">
          <div className="flex items-center gap-2 mb-2">
          <Input
            placeholder="Search..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="h-8"
          />
          { !(value.length === filteredOptions.length) && (
          <Button  className="h-7 text-xs" onClick={() => handleToggleAll()}>
            Select All
          </Button>)}
          </div>
          {/* {
            filteredOptions.length > 1 && (
              <div
                  key="select-all"
                  className="flex items-center space-x-2 py-1.5 px-2 rounded-md hover:bg-gray-50 cursor-pointer border-b border-gray-200"
                  onClick={() => handleToggleAll()}
                >
                  <Checkbox
                    checked={value.length === filteredOptions.length}
                    onCheckedChange={() => handleToggleAll()}
                    className="data-[state=checked]:bg-primary data-[state=checked]:border-primary"
                  />
                  <Label
                    className={cn(
                      "text-sm font-normal cursor-pointer flex-1",
                      true ? "text-gray-900" : "text-gray-700",
                    )}
                  >
                    Select All 
                  </Label>
                </div>
            )
          } */}
          <div className="space-y-1 max-h-[300px] overflow-y-auto pr-1">
            {filteredOptions.map((option) => {
              const isChecked = value.includes(option.key);
              return (
                <div
                  key={option.key}
                  className="flex items-center space-x-2 py-1.5 px-2 rounded-md hover:bg-gray-50 cursor-pointer"
                  onClick={() => handleToggle(option.key)}
                >
                  <Checkbox
                    checked={isChecked}
                    onCheckedChange={() => handleToggle(option.key)}
                    className="data-[state=checked]:bg-primary data-[state=checked]:border-primary"
                  />
                  <Label
                    className={cn(
                      "text-sm font-normal cursor-pointer flex-1",
                      isChecked ? "text-gray-900" : "text-gray-700",
                    )}
                  >
                    {option.label}
                  </Label>
                </div>
              );
            })}
            {filteredOptions.length === 0 && (
              <p className="px-2 py-3 text-xs text-muted-foreground">No caretaker found</p>
            )}
          </div>
          {value.length > 0 && (
            <div className="mt-3 pt-3 border-t flex  items-center justify-between">
                 <Button
                variant="ghost"
                size="sm"
                className="h-7 text-xs text-destructive border-destructive hover:bg-destructive/30 hover:text-destructive"
                onClick={() => {
                  setValue([]);
                  if (applyOnClearAll) {
                    handleSelectionDone([]);
                    onSelectedValuesChange?.([]);
                    // setPreValues([]);
                    setOpen(false);
                  }
                }}
              >
                Clear all
              </Button>
              {/* <span className="text-xs text-gray-500">
                {value.length} selected
              </span> */}
             
              <Button
                variant="ghost"
                size="sm"
                className="h-7 text-xs"
                onClick={() => {
                  handleSelectionDone(value);
                  onSelectedValuesChange?.(value);
                  // setPreValues(value);
                  setOpen(false);
                  if (resetOnDone) setValue([]);
                }}
              >
             Done
              </Button>
            </div>
          )}
        </div>
      </PopoverContent>
    </Popover>
  );
};

export default AssignMultiSelect;
